import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RegisterService } from 'src/app/Services/register.service';
import { AppSettings } from '../../app.settings';
import { Settings } from '../../app.settings.model';
import { rotate } from 'src/app/theme/utils/app-animation';
import { EmailVerificationPopupComponent } from './email-verification-popup/email-verification-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { PidSelectComponent } from './pid-select/pid-select.component';
import * as shajs from 'sha.js';

@Component({
    selector: "app-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
    animations: [rotate],
})
export class RegisterComponent implements OnInit {
    registerForm: FormGroup;
    public settings: Settings;
    public showInfoContent: boolean = false;

    hoi_email: any = "";
    institute_name: any = "";
    address: any = "";
    instituteId: any;
    error: any;
    states: any = [];
    organisations: any = [];
    departments: any = [];
    category: any;
    designations: any = [];
    designationsFlag = 0;
    instituteTypeFlag: number = 3;
    institutes: any;
    payScales: any;
    departmentsTemp: any;
    designationsTemp: any;
    retiredProfessor: boolean;
    streams: any;

    constructor(
        public dialog: MatDialog,
        private register: RegisterService,
        public appSettings: AppSettings,
        private toastr: ToastrService,
        public fb: FormBuilder,
        public router: Router
    ) {
        this.settings = this.appSettings.settings;
    }

    ngOnInit(): void {
        this.createForm();
        this.register
            .getRegistrationDetails()
            .subscribe((response) => this.settingFormValues(response));
    }

    createForm() {
        this.registerForm = this.fb.group({
            name: ["", [Validators.required, Validators.minLength(3)]],
            role_id: ["", Validators.required],
            email: ["", [Validators.required, Validators.email]],
            mobile: [
                "",
                [Validators.required, Validators.pattern("[56789][0-9]{9}")],
            ],
            pan_number: [null, Validators.compose([Validators.pattern('^[A-Z]{5}[0-9]{4}[A-Z]{1}$')])],
            stream: ["", Validators.required],
            department: ["", Validators.required],
            organisationType: ["", Validators.required],
            affiliation_type: ["", Validators.required],
            institute_permanent_id: [""],
            instituteType: [""],
            institute_name: [""],
            institute_address: [""],
            pay_scale: [""],
            state: [""],
            designation: ["", Validators.required],
            experience: [
                "",
                [Validators.required, Validators.min(8), Validators.max(60)],
            ],
            password: [
                null,
                Validators.compose([
                    Validators.required,
                    Validators.minLength(8),
                    Validators.pattern(
                        "(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$"
                    ),
                ]),
            ],
            confirmPassword: [
                null,
                Validators.compose([
                    Validators.required,
                    Validators.pattern(
                        "(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$"
                    ),
                ]),
            ],
        });

    }

    settingFormValues(response: any) {
        this.streams = response['streams'];
        this.states = response["state"];
        this.organisations = response["organizationType"];
        this.institutes = response["instituteType"];
        this.payScales = response["payScale"];
        this.designationsTemp = response["designation"];
    }

    onStreamSelection(event: any) {
        this.register.fetchDepartments(event.value).subscribe((data) => {
            if (data["type"] == "Success") {
                this.departments = data["Departments"];
            }
        });
    }

    onOrganisationSelect(event: any) {
        this.designations = [];
        this.instituteTypeFlag = event.value;
        if (event.value == 1) {
            this.designationsTemp.forEach((element) => {
                if (element["id"] != "5") {
                    this.designations.push(element);
                }
            });
            this.registerForm.controls["state"].setValidators([Validators.required]);
            this.registerForm.controls["institute_permanent_id"].setValidators([
                Validators.required,
            ]);
            this.registerForm.controls["instituteType"].setValidators([
                Validators.required,
            ]);
            this.registerForm.controls["institute_name"].setValidators([
                Validators.required,
            ]);
            this.registerForm.controls["institute_address"].setValidators([
                Validators.required,
            ]);
            this.registerForm.controls["pay_scale"].setValidators([
                Validators.required,
            ]);
        } else if (event.value == 2) {
            this.designationsTemp.forEach((element) => {
                if (element["id"] != "5") {
                    this.designations.push(element);
                }
            });
            this.registerForm.controls["state"].setValidators([Validators.required]);
            this.registerForm.controls["state"].setValue(null);

            this.registerForm.controls["institute_permanent_id"].clearValidators();
            this.registerForm.controls["institute_permanent_id"].setValue(null);

            this.registerForm.controls["instituteType"].setValidators([
                Validators.required,
            ]);
            this.registerForm.controls["instituteType"].setValue(null);

            this.registerForm.controls["institute_name"].setValidators([
                Validators.required,
            ]);
            this.registerForm.controls["institute_name"].setValue(null);

            this.registerForm.controls["institute_address"].setValidators([
                Validators.required,
            ]);
            this.registerForm.controls["institute_address"].setValue(null);

            this.registerForm.controls["pay_scale"].setValidators([
                Validators.required,
            ]);
            this.registerForm.controls["pay_scale"].setValue(null);
        } else {
            this.designationsTemp.forEach((element) => {
                if (element["id"] == "5") {
                    this.designations.push(element);
                }
            });
            this.registerForm.controls["state"].clearValidators();
            this.registerForm.controls["institute_permanent_id"].clearValidators();
            this.registerForm.controls["instituteType"].clearValidators();
            this.registerForm.controls["institute_name"].clearValidators();
            this.registerForm.controls["institute_address"].clearValidators();
            this.registerForm.controls["pay_scale"].clearValidators();
        }
        this.registerForm.controls[
            "institute_permanent_id"
        ].updateValueAndValidity();
        this.registerForm.controls["state"].updateValueAndValidity();
        this.registerForm.controls["instituteType"].updateValueAndValidity();
        this.registerForm.controls["institute_name"].updateValueAndValidity();
        this.registerForm.controls["institute_address"].updateValueAndValidity();
        this.registerForm.controls["pay_scale"].updateValueAndValidity();
    }

    onDesignationSelect(event) {
        if (event.value == 4 && this.instituteTypeFlag != 3) {
            this.retiredProfessor = true;
        } else {
            this.retiredProfessor = false;
        }
    }

    PIDSelect() {
        const dialogRef = this.dialog.open(PidSelectComponent, {
            height: '75%'
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.setInstituteValues(result["data"]);
            }
        });
    }

    setInstituteValues(data) {
        this.registerForm.controls["institute_permanent_id"].setValue(
            data["PERMANENT_ID"]
        );
        this.registerForm.controls["institute_name"].setValue(
            data["CURRENT_INSTITUTE_NAME"]
        );
        this.registerForm.controls["institute_address"].setValue(
            data["CURRENT_INSTITUTE_ADDRESS"]
        );

        this.states.forEach((element) => {
            if (element.state == data["INSTI_STATE"]) {
                this.registerForm.controls.state.setValue(element.id);
            }
        });

        this.institutes.forEach((element) => {
            if (element.institute_type == data["degree_diploma"]) {
                this.registerForm.controls.instituteType.setValue(element.id);
            }
        });
    }

    checkNumber(event: any): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    onSubmit(values) {

        if (this.registerForm.valid) {
            this.settings.loadingSpinner = true;
            if (values.password == values.confirmPassword) {
                let tempEmail = this.registerForm.controls.email.value;
                let lowerCaseEmail = tempEmail.toLowerCase();
                let encryptedEmail = btoa(lowerCaseEmail);
                // let encryptedEmail = btoa(this.registerForm.controls.email.value);
                let encryptedPassword = shajs('sha512').update(this.registerForm.controls.password.value + encryptedEmail).digest('hex');
                values['password'] = encryptedPassword;
                values['confirmPassword'] = shajs('sha512').update(this.registerForm.controls.confirmPassword.value + encryptedEmail).digest('hex');
                values['email'] = encryptedEmail;
                this.register.submitRegistration(values).subscribe(
                    (response) => this.handleResponse(response),
                    (error) => this.handleError(error)
                );
            } else {
                this.toastr.error("Password confirmation does not match!");
            }
        } else {
            this.toastr.error("Kindly fill all the details");
        }
    }

    handleResponse(data) {
        if (data["type"] == "Success") {
            this.verifyEmailPopup();
        } else {
            this.toastr.error(data["message"]);
        }
    }

    handleError(error) {
        this.error = error.error.errors;
        this.toastr.error(error.error.errors);
    }

    verifyEmailPopup() {
        const dialogRef = this.dialog.open(EmailVerificationPopupComponent);
        dialogRef.afterClosed().subscribe(() => {
            this.ngOnInit();
        });
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode >= 48 && charCode <= 57) return true;

        return false;
    }

    isSpace(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode == 32) {
            return false;
        }
        return true;
    }

    checkChar(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
            (charCode >= 65 && charCode <= 90) ||
            (charCode >= 97 && charCode <= 122) ||
            charCode == 32
        )
            return true;

        return false;
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.settings.loadingSpinner = false;
        }, 300);
    }
}  